var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPermission && _vm.showButton)?_c('v-btn',{staticClass:"mr-2",attrs:{"disabled":_vm.disabled,"outlined":"","small":"","color":_vm.color || 'primary'},on:{"click":function($event){return _vm.$emit('action')}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.icon || "add_circle"))]),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }